/** Events that carry a browser session_id (one per tab visit). */
export function countDistinctSessions(
  events: ReadonlyArray<{ session_id: string | null }>,
): number {
  const ids = new Set<string>();
  for (const e of events) {
    if (e.session_id) ids.add(e.session_id);
  }
  return ids.size;
}
